export default __webpack_public_path__ + "static/media/Refined Elixir of Brute Force.8525fd2c.jpg";